import React from 'react';

/* COMPLETE / NEEDS WORK / EMPTY for one Recruit ▸ Me section.
   Derived from data already on the page — no new endpoint. */
const LABEL = { complete: 'COMPLETE', partial: 'NEEDS WORK', empty: 'EMPTY' };

export default function StatusChip({ id, state }) {
  return (
    <span className={`me-chip me-chip--${state}`} data-testid={`me_status_${id}`}>
      {LABEL[state]}
    </span>
  );
}

/** filled/total → chip state. Exported so sections agree on the thresholds. */
export function chipState(filled, total) {
  if (!total || filled === 0) return 'empty';
  return filled >= total ? 'complete' : 'partial';
}
